import { GET_LOCATION_ADS_API_BASE, CODE_PARAM, V2_CLIENT_CODE_KEY } from '../Constants/APIConstantsV2';

const getAds = (location) => {
    let url = new URL(`${GET_LOCATION_ADS_API_BASE}${location}`);
    url.searchParams.append(CODE_PARAM, V2_CLIENT_CODE_KEY);

    return fetch(url, {});
}

export default getAds;